const ORIGIN = 'https://omoimusubi.asia';
const PUBLISHER = {
  '@type': 'Organization',
  name: '株式会社cafoot',
  url: ORIGIN + '/',
  logo: ORIGIN + '/brand/logo.png',
};

interface Props {
  canonical?: string;
  /** 見出し名（h1など、サフィックス無しの綺麗な名前が望ましい） */
  name: string;
  description: string;
}

/**
 * 既存で「ページ種別スキーマ」が無いページ（PageShell配下・contact・free-trial）に、
 * canonical のパスから種別を判定して JSON-LD を1本だけ付与する。
 * - /compare|/templates 配下 … Article
 * - /contact/            … ContactPage
 * - それ以外(機能/料金/セキュリティ/法務/無料トライアル等) … WebPage
 * ※BreadcrumbList は Layout の <Breadcrumb> が全ページで既に出しているので、ここでは出さない（重複回避）。
 * ※トップ(home/page.tsx)とガイド(GuideLayout=Article)は各自出力済みのため対象外。
 */
export default function PageJsonLd({ canonical, name, description }: Props) {
  if (!canonical) return null;
  let pathname: string;
  try {
    pathname = new URL(canonical).pathname;
  } catch {
    return null;
  }
  if (pathname === '/') return null;

  const isArticle = /^\/(compare|templates)\//.test(pathname);
  const node = isArticle
    ? {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: name.length > 110 ? name.slice(0, 110) : name,
        description,
        url: canonical,
        image: ORIGIN + '/brand/logo.png',
        author: PUBLISHER,
        publisher: PUBLISHER,
        mainEntityOfPage: { '@type': 'WebPage', '@id': canonical },
        inLanguage: 'ja',
      }
    : {
        '@context': 'https://schema.org',
        '@type': pathname === '/contact/' ? 'ContactPage' : 'WebPage',
        name,
        description,
        url: canonical,
        inLanguage: 'ja',
        isPartOf: { '@type': 'WebSite', name: 'おもいむすび', url: ORIGIN + '/' },
      };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(node) }} />;
}
